<template>
  <p class="user-recommends">
    <span class="recommend-item">
      <span
        class="recommend-icon"
        :class="[recommend ? 'tick' : 'cross']"
      /><translate>Recommend to friends</translate>
    </span>
    <span class="recommend-item">
      <span
        class="recommend-icon"
        :class="[revisit ? 'tick' : 'cross']"
      /><translate>Visit again</translate>
    </span>
  </p>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteReviewRecommend extends Vue {
  @Prop({ default: true })
  recommend: boolean

  @Prop({ default: true })
  revisit: boolean
}

export default toNative(CampsiteReviewRecommend)
</script>

<style scoped>
.user-recommends {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 1em;
}

.recommend-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f5f6f8;
  border-radius: var(--border-radius);
  padding: 0.2em 0.6em 0.2em 0.4em;
}

.recommend-icon {
  width: 0.9em;
  height: 0.9em;
  display: inline-block;
  flex-shrink: 0;
  margin-right: 0.3em;
}

.recommend-icon.tick {
  background: url('~/assets/images/tick.svg') no-repeat center center;
}

.recommend-icon.cross {
  background: url('~/assets/images/x-red.svg') no-repeat center center;
  width: 0.8em;
  height: 0.8em;
}
</style>
